const features = [
  {
    icon: 'ri-4k-line',
    title: '1080P高清画质',
    desc: '支持最高1080P超清播放，每一帧都清晰细腻，给你影院级观看体验',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载不卡顿',
    desc: '全球CDN加速节点覆盖，即点即播无需等待，看动漫就是要流畅',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读体验',
    desc: '独创下拉式追更模式，像刷短视频一样追漫画，单手操作超方便',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与日本、韩国、国内同步更新，第一时间追到最新番剧，绝不错过',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费无广告',
    desc: '全站资源免费观看，拒绝付费墙，动漫就应该让所有人自由欣赏',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">特色优势</h2>
          <p className="mt-3 text-sm text-foreground-600">为什么千万动漫迷选择51动漫网？五大核心优势告诉你答案</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div key={idx} className="flex flex-col items-center text-center p-6 rounded-2xl bg-background-50 border border-background-200/70 transition-all hover:-translate-y-1 cursor-default">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}